import React, { useEffect } from 'react';
import { Button, Form, FormGroup } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { useMutation, useQuery } from 'react-query';
import { useNavigate, useParams } from 'react-router';
import Contents from 'components/Layout/Contents';
import { Input } from 'components/Forms';
import CompetencyService from 'api/CompetencyService';
import Spinner from 'components/Spinner/Spinner';
import Alert from 'components/Alert/Alert';
import './SpecialtyForms.scss';

export default function EditCompetency() {
  const { specialtyId } = useParams();
  // noinspection DuplicatedCode
  const navigate = useNavigate();
  const { handleSubmit, control, setValue } = useForm({
    defaultValues: {
      id: '',
      referenceId: '',
      name: '',
    },
  });
  const { isLoading, isError, error, refetch } = useQuery(
    ['specialties', specialtyId],
    () => CompetencyService.getById(specialtyId),
    {
      onSuccess: ({ data }) => {
        if (data) {
          setValue('id', data.id);
          setValue('referenceId', data.referenceId);
          setValue('name', data.name);
        }
      },
    }
  );
  const mutation = useMutation((payload) => CompetencyService.update(payload));
  const onSubmit = (formData) => {
    mutation.mutate(formData);
  };
  useEffect(() => {
    if (specialtyId) {
      refetch();
    }
  }, [specialtyId]);

  if (isLoading) {
    return <Spinner />;
  }

  if (isError) {
    return (
      <>
        <h2>There is an error</h2>
        <p className="alert alert-danger">{error.message}</p>
      </>
    );
  }

  return (
    <Contents title="Edit Specialty">
      <div className="edit-specialty">
        {mutation.isLoading && (
          <Alert
            variant="info"
            title="Processing"
            iconProps={{ spin: true, pulse: true }}
          >
            Updating specialty...
          </Alert>
        )}
        {mutation.isError && (
          <Alert variant="danger" title="Error">
            An error occurred: {mutation.error.message}
          </Alert>
        )}
        {mutation.isSuccess && (
          <Alert variant="success" title="Processing">
            Specialty details updated.
          </Alert>
        )}
        <Form onSubmit={handleSubmit(onSubmit)}>
          <FormGroup>
            <Input
              label="ID"
              control={control}
              name="referenceId"
              placeholder="ID"
              rules={{ required: true }}
              disabled={mutation.isLoading}
            />
          </FormGroup>
          <FormGroup>
            <Input
              label="Name"
              control={control}
              name="name"
              placeholder="Name"
              rules={{ required: true }}
              disabled={mutation.isLoading}
            />
          </FormGroup>
          <FormGroup>
            <div className="mt-3 d-block">
              <Button
                variant="primary"
                className="btn-pmi"
                type="submit"
                disabled={mutation.isLoading}
              >
                Save
              </Button>
              <Button
                variant="link"
                className="d-inline-block ms-3"
                disabled={mutation.isLoading}
                onClick={() => navigate('/competencies')}
              >
                Cancel
              </Button>
            </div>
          </FormGroup>
        </Form>
      </div>
    </Contents>
  );
}
